import { Subscribable } from 'knockout';

const groups = new Map<string, Array<Subscribable<FancyBoxGroupItem | undefined>>>();

export function getOrCreateGroup(name: string) {
    let group = groups.get(name);

    if (group == undefined)
        groups.set(name, group = []);

    return group;
}

export function cleanUpGroups() {
    const toRemove = <Array<string>>[];

    groups.forEach((value: Array<any>, key: string) => {
        if (value.length == 0)
            toRemove.push(key);
    });

    toRemove.forEach(key => groups.delete(key));
}

export function withProxy<T>(items: Array<T>, methods: Array<keyof T>) {
    return methods.reduce((result, method) => {
        (<any>result)[method] = (...args: Array<any>) => {
            items.forEach(item => {
                if (_.isFunction(item[method]))
                    (<any>item[method])(...args);
            });
        }

        return result;
    }, <T>{});
}